export function renderContact(): string {
  return /* html */`
<div class="page-wrapper contact-page">
  <div class="page-hero">
    <span class="section-label">${L('Kontakt', 'Contact')}</span>
    <h1 class="hero-title anim-fade-up">
      <span class="gradient-text">${L('Sag etwas.', 'Say something.')}</span>
    </h1>
    <p class="hero-mission anim-fade-up" style="animation-delay:0.1s">
      ${L(
        'Sitz in Dresden, Deutschland. Erreichbar per E-Mail und GitHub. Wir lesen alles. Wir antworten nicht immer schnell, aber wir antworten.',
        'Based in Dresden, Germany. Available via email and GitHub. We read everything. We don\'t always respond quickly, but we do respond.'
      )}
    </p>
  </div>

  <div class="page-section contact-layout">
    <!-- Contact form -->
    <div class="contact-form-wrap">
      <h2 class="section-title" style="font-size:var(--text-2xl);margin-bottom:var(--s6)">${L('Nachricht senden', 'Send a message')}</h2>

      <form id="contact-form" class="contact-form" novalidate>
        <div class="form-group">
          <label for="contact-name" class="form-label">${L('Dein Name', 'Your name')}</label>
          <input type="text" id="contact-name" name="name" class="form-input"
                 placeholder="Ada Lovelace" required autocomplete="name"/>
        </div>

        <div class="form-group">
          <label for="contact-email" class="form-label">Email</label>
          <input type="email" id="contact-email" name="email" class="form-input"
                 placeholder="ada@beispiel.de" required autocomplete="email"/>
        </div>

        <div class="form-group">
          <label for="contact-subject" class="form-label">${L('Betreff', 'Subject')}</label>
          <select id="contact-subject" name="subject" class="form-input">
            <option value="general">${L('Allgemeine Anfrage', 'General inquiry')}</option>
            <option value="collab">${L('Zusammenarbeit / Partnerschaft', 'Collaboration / partnership')}</option>
            <option value="business">${L('Geschäftliche Anfrage', 'Business inquiry')}</option>
            <option value="bug">${L('Fehlerbericht', 'Bug report')}</option>
            <option value="hiring">${L('Karriere / Jobs', 'Hiring / careers')}</option>
            <option value="other">${L('Etwas anderes', 'Something else')}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="contact-message" class="form-label">${L('Nachricht', 'Message')}</label>
          <textarea id="contact-message" name="message" class="form-input form-textarea"
                    placeholder="${L('Was beschäftigt dich?', "What's on your mind?")}" required rows="5"></textarea>
        </div>

        <button type="submit" class="btn btn-primary" style="width:100%">
          ${L('Nachricht senden', 'Send message')}
        </button>

        <div id="form-result" class="form-result hidden"></div>
      </form>
    </div>

    <!-- Contact info panel -->
    <div class="contact-info-panel">
      <div class="contact-info-card card">
        <h3 class="contact-info-title">${L('Direkter Kontakt', 'Direct lines')}</h3>
        <ul class="contact-list">
          <li class="contact-item">
            <span class="contact-icon">✉</span>
            <div>
              <div class="contact-item-label">Email</div>
              <a href="mailto:info@dresby.de" class="contact-link">info@dresby.de</a>
            </div>
          </li>
          <li class="contact-item">
            <span class="contact-icon">🐙</span>
            <div>
              <div class="contact-item-label">GitHub</div>
              <a href="https://github.com/xirtus" class="contact-link" target="_blank" rel="noopener">
                github.com/xirtus ↗
              </a>
            </div>
          </li>
          <li class="contact-item">
            <span class="contact-icon">📍</span>
            <div>
              <div class="contact-item-label">${L('Standort', 'Location')}</div>
              <span class="contact-link">Dresden, Deutschland</span>
            </div>
          </li>
        </ul>
      </div>

      <div class="contact-collab card" style="margin-top:var(--s4)">
        <h3 class="contact-info-title">${L('Zusammenarbeit', 'Collaboration')}</h3>
        <p style="color:var(--text-2);font-size:var(--text-sm);margin-bottom:var(--s4)">
          ${L(
            'Wir sind offen für die Zusammenarbeit mit anderen unabhängigen Entwicklern, Designern, Künstlern und Forschern. Wenn du etwas Interessantes baust und denkst, Dresby könnte helfen oder beitragen, melde dich.',
            'We\'re open to collaborating with other independent developers, designers, artists, and researchers. If you\'re building something interesting and think Dresby could help or contribute, reach out.'
          )}
        </p>
        <p style="color:var(--text-2);font-size:var(--text-sm)">
          ${L(
            'Wir sind besonders interessiert an: Local-First-Anwendungen, KI-Tools für kreative Arbeit, Open-Source-Infrastruktur und allem, was in der Dresdner Tech-Community passiert.',
            'We\'re especially interested in: local-first applications, AI tools for creative work, open-source infrastructure, and anything happening in the Dresden tech community.'
          )}
        </p>
      </div>

      <div class="contact-location card" style="margin-top:var(--s4)">
        <div class="location-visual" aria-hidden="true">
          <div class="location-dot"></div>
          <div class="location-rings"></div>
          <span class="location-label">Dresden, Deutschland 🏰</span>
        </div>
        <p style="color:var(--text-3);font-size:var(--text-xs);margin-top:var(--s3);font-family:var(--font-mono)">
          51.0504° N, 13.7373° E
        </p>
      </div>
    </div>
  </div>
</div>
`;
}

import { i18n } from '../lib/i18n.ts';
function L(de: string, en: string): string { return i18n.current === 'de' ? de : en; }

export function initContact(): void {
  const form = document.getElementById('contact-form') as HTMLFormElement;
  const result = document.getElementById('form-result');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
    btn.disabled = true;
    btn.textContent = i18n.current === 'de' ? 'Wird gesendet...' : 'Sending...';

    // Simulate send (replace with real endpoint)
    await new Promise(r => setTimeout(r, 800));

    if (result) {
      result.classList.remove('hidden', 'form-result--error');
      result.classList.add('form-result--success');
      result.innerHTML = i18n.current === 'de' ? `
        <strong>Nachricht erhalten.</strong> Wir melden uns in Kürze.
        <br/><small>Schau in der Zwischenzeit auf <a href="https://github.com/xirtus" target="_blank">github.com/xirtus</a> vorbei.</small>
      ` : `
        <strong>Message received.</strong> We'll be in touch soon.
        <br/><small>In the meantime, check out <a href="https://github.com/xirtus" target="_blank">github.com/xirtus</a>.</small>
      `;
    }
    form.reset();
    btn.disabled = false;
    btn.textContent = i18n.current === 'de' ? 'Nachricht senden' : 'Send message';

    // TODO: Wire to actual backend (Resend, Formspree, or custom FastAPI endpoint)
  });
}
